import { render, staticRenderFns } from "./SectionRealization.vue?vue&type=template&id=610f6a22&"
import script from "./SectionRealization.vue?vue&type=script&lang=js&"
export * from "./SectionRealization.vue?vue&type=script&lang=js&"
import style0 from "./SectionRealization.vue?vue&type=style&index=0&lang=scss&module=w&"




function injectStyles (context) {
  
  this["w"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports